import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Icons as simple components
const ArrowRight = () => <span>→</span>;
const ArrowDown = () => <span>↓</span>;
const Download = () => <span>📥</span>;
const Github = () => <span>⚡</span>;
const Linkedin = () => <span>💼</span>;
const Twitter = () => <span>🐦</span>;

const HeroSection = () => {
  const [currentSkill, setCurrentSkill] = useState(0);
  const skills = [
    "React Developer",
    "Full Stack Engineer",
    "UI/UX Designer",
    "Mobile App Developer",
  ];
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSkill((prev) => (prev + 1) % skills.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero__background">
        <div className="floating-shapes">
          <div className="shape shape--1"></div>
          <div className="shape shape--2"></div>
          <div className="shape shape--3"></div>
          <div className="shape shape--4"></div>
        </div>
      </div>

      <div className="container">
        <div className="hero__content">
          <div className="hero__text">
            <div className="hero__badge">
              <span className="badge__dot"></span>
              <span>👋 Hi, I'm Chhatrapal Choudhary</span>
            </div>

            <h1 className="hero__title">
              Building Powerful
              <br />
              <span className="title__gradient">Web Applications</span>
              <br />
              <span className="title__dynamic">{skills[currentSkill]}</span>
            </h1>

            <p className="hero__description">
              Crafting User-Centric Experiences That Inspire & Drive Business
              Growth with <span className="text--accent">7+ years</span> of
              expertise in React, Node.js, and React Native.
            </p>

            <div className="hero__stats">
              <div className="stat">
                <div className="stat__number">20+</div>
                <div className="stat__label">Projects Completed</div>
              </div>
              <div className="stat">
                <div className="stat__number">15+</div>
                <div className="stat__label">Happy Clients</div>
              </div>
              <div className="stat">
                <div className="stat__number">7+</div>
                <div className="stat__label">Years Experience</div>
              </div>
            </div>

            <div className="hero__actions">
              <button
                className="btn btn--primary"
                onClick={() => navigate("/case-studies")}
              >
                <span>Recent Work</span>
                <ArrowRight />
              </button>

              {/* <button className="btn btn--secondary">
                <Download />
                <span>Download CV</span>
              </button> */}
            </div>

            <div className="hero__social">
              <span className="social__label">Follow me:</span>
              <div className="social__links">
                <a
                  href="https://github.com/chhatrapalchoudhaary"
                  className="social__link"
                >
                  <Github />
                </a>
                <a
                  href="https://www.linkedin.com/in/chhatrapal-choudhary-143a3881/"
                  className="social__link"
                >
                  <Linkedin />
                </a>
                <a href="https://x.com/web_chhatrapal" className="social__link">
                  <Twitter />
                </a>
              </div>
            </div>
          </div>

          <div className="hero__visual">
            <div className="profile">
              <div className="profile__image">
                <div className="profile__avatar">
                  <img
                    src="/img/hero-img.png"
                    alt="Chhatrapal Choudhary - Full Stack Developer"
                  />
                </div>
              </div>
              <div className="floating-icons">
                <div className="floating-icon floating-icon--1">⚛️</div>
                <div className="floating-icon floating-icon--2">📱</div>
                <div className="floating-icon floating-icon--3">🌐</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll__icon">
          <ArrowDown />
        </div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default HeroSection;
